export enum PlayerState {
  BUFFERING = 'buffering',
  IDLE = 'idle',
  PAUSED = 'paused',
  PLAYING = 'playing',
  COMPLETE = 'complete',
}
